// @flow
import React from 'react';

import Annuaire from 'components/fragments/Annuaire';
import Embedtwitch from 'components/embedTwitch';
import Component from 'containers/newsletter/blocs/HtmlElementWrapperContainer';
import HTMLGallery from 'components/newsletter/blocs/HTMLGallery/HTMLGallery';
import HTMLAccordion from 'components/newsletter/blocs/HTMLAccordion/HTMLAccordion';
import NewsletterSubscriberContainer from 'containers/footer/NewsletterSubscriberContainer';
import HtmlScript from 'components/newsletter/blocs/HtmlScript';
import Download from 'containers/fragments/DownloadContainer';
import CardEnDirect from 'containers/fragments/CardEnDirectContainer';
import CardMap from 'components/fragments/card/CardMap';
import AlbumGallery from 'containers/fragments/AlbumGalleryContainer';

import type { BlocContent } from 'types/NewsletterBloc';

import { blacklist } from 'constants/newsletterBlocConstants';
import { FB_API_KEY } from 'constants/app.js';
import FacebookProvider, { EmbeddedPost } from 'react-facebook-sdk';
import CardEvent from 'components/fragments/card/CardEvent';
import './facebookBloc.css';

const ContentBloc = (props: BlocContent) => {
  const { attributes, children, tagName } = props;

  if (tagName === 'embed-twitch' && !!attributes) {
    return <Embedtwitch attributes={attributes} />;
  }

  if ((tagName === 'figure' && children && children.length > 0 && children[0].tagName === 'galleryalbum') || tagName === 'galleryalbum') {
    let content = !!children && !!children.length ? children[0] : [];
    if (content.tagName === 'gallery-item-wp-593') {
      content = { children };
    }

    return <AlbumGallery content={content} />;
  }

  if (tagName === 'evenement') {
    const propsEvent =
      attributes && attributes.length > 0 ? JSON.parse(attributes[0].value) : { title: false, link: false, ical: false, label: false };
    if (propsEvent && propsEvent.title && propsEvent.link && propsEvent.ical && propsEvent.start_day && propsEvent.start_hour) {
      return <CardEvent {...propsEvent} />;
    } else {
      return null;
    }
  }

  if (tagName === 'openstreetmap' && attributes) {
    const cardProps = attributes.reduce((acc, { name, value }) => {
      if (name === 'lat' || name === 'lon' || name === 'long') {
        acc[name] = value.replace(',', '.');
      } else {
        acc[name] = value;
      }
      return acc;
    }, {});

    return <CardMap {...cardProps} />;
  }

  if (tagName === 'gallery' && children) {
    const galleryAttributes = attributes ? attributes : [];
    return <HTMLGallery childrens={children} attributes={galleryAttributes} tagName={tagName} />;
  }

  if (tagName === 'newsletter') {
    return (
      <div className="box card card--newsletter mb-4">
        <div className="card__thumbnail img-blue-dark" style={{ backgroundImage: 'url(/img/card/bg-game.jpg)' }} />
        <NewsletterSubscriberContainer mode={'sidebar'} />
      </div>
    );
  }

  if (tagName === 'accordeon') {
    if (children && attributes) {
      return <HTMLAccordion childrens={children} attributes={attributes} tagName={tagName} />;
    }
  }

	if (tagName === 'annuaire') {
		if (attributes && attributes[0].name === 'data-annuaire') {
			const annuaire = JSON.parse(attributes[0].value.replace(/\s:/g, ':'));
			return <Annuaire annuaire={annuaire} />;
		}
		if (attributes && attributes[0].name === 'type') {
			const annuaire = JSON.parse(attributes[1].value.replace(/\s:/g, ':'));
			return <Annuaire type={attributes[0].value} annuaire={annuaire} />;
		}
	}

  if (tagName === 'download') {
    const attrs = {};
    if (attributes && attributes.length > 0) {
      attributes.forEach(function(attr, index) {
        attrs[attr.name] = attr.value;
      });
    }
    return <Download {...attrs} />;
  }

  if (tagName === 'cardendirect') {
    return <CardEnDirect />;
  }

  if (tagName === 'facebook') {
    const attr = attributes && attributes.length > 0 && attributes.find(attr => attr.name === 'cite');
    if (attr !== null && attr !== undefined && attr.value !== null) {
      return (
        <FacebookProvider appId={FB_API_KEY}>
          <EmbeddedPost href={attr.value} />
        </FacebookProvider>
      );
    }
  }

  if (tagName && !blacklist.includes(tagName)) {
    return <Component childrens={children} attributes={attributes} tagName={tagName} />;
  } else {
    return <HtmlScript childrens={children} attributes={attributes} />;
  }
};

export default ContentBloc;
